export enum Locale {
  en = 'en-US',
  // zh = 'zh-CN',
  ja = 'ja-JP',
}
